import cookieUniversal from 'cookie-universal';
export default ((_ref, inject) => {
  var {
    req,
    res
  } = _ref;
  var options = {
    "alias": "cookies",
    "parseJSON": true
  };
  inject(options.alias, cookieUniversal(req, res, options.parseJSON));
});